import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { query } from '@warp-drive/utilities/json-api';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import type { Store as StoreService } from '@warp-drive/core';
import type SessionContextService from 'tio-employee/services/session-context';

export default class AuthenticatedIdrDashboardIndexRoute extends Route {
  @service declare store: StoreService;
  @service declare sessionContext: SessionContextService;

  async model() {
    const { content } = (await this.store.request(
      query<RecommendationModel>('recommendation', {
        'filter[user]': this.sessionContext.user.id,
        'filter[requesting-app]': 'IDR',
        include: 'user',
        sort: '-created-at',
        'page[offset]': 0,
      })
    )) as { content: { data: RecommendationModel[] } };

    return {
      allRecommendations: content.data,
    };
  }
}
